import MenuWidget from './menu-widget'

export default MenuWidget
